<div class="{{localService.selectedLanguageCode}} freeze_height"
  *ngIf="localService.languageContent && localService.languageContent.local_locations && locations">
  <div *ngIf="!isVertical">
    <div class="row">
      <div [ngClass]="isExpand ? 'col-md-3' : 'col-3'" *ngIf="!IsShowPostalCode">
        <div style="width:40px;float:left;" *ngIf="localService.windowWidth <= 900">
          <i style="top:4px;" class="material-icons button icon_adjust" [ngClass]="isExpand ? 'arrow_up' : 'arrow_down'"
            (click)="onToggleExpand()">double_arrow</i>
        </div>
        <div [ngStyle]="{'width' : 'calc(100% - ' + (localService.windowWidth <= 900 ? 40 : 0) + 'px)'}"
          style="float:left;">
          <ngx-select (select)="onLocationChanged(1)" [optionValueField]="'key'" [optionTextField]="'value'"
            [items]="locations.countries" [(ngModel)]="locations.selected.v1"
            placeholder="{{localService.languageContent.local_locations.select_country}}"
            title="{{localService.languageContent.local_locations.select_country}}"
            [disabled]="locations.selected.v1 != '' && locations.countries.length == 1" [noAutoComplete]="true">
            <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
              <span [ngClass]="localService.selectedLanguageCode + '_medium'">{{option.data.value}}</span>
            </ng-template>
          </ngx-select>
        </div>
      </div>
      <div [ngClass]="isExpand ? 'col-md-3' : 'col-3'">
        <div style="width:40px;float:left;" *ngIf="IsShowPostalCode && localService.windowWidth <= 900">
          <i style="top:4px;" class="material-icons button icon_adjust" [ngClass]="isExpand ? 'arrow_up' : 'arrow_down'"
            (click)="onToggleExpand()">double_arrow</i>
        </div>
        <div
          [ngStyle]="{'width' : 'calc(100% - ' + (IsShowPostalCode && localService.windowWidth <= 900 ? 40 : 0) + 'px)'}"
          style="float:left;">
          <ngx-select (select)="onLocationChanged(2)" [optionValueField]="'key'" [optionTextField]="'s_value'"
            [items]="locations.states.contents" [(ngModel)]="locations.selected.v2"
            placeholder="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryId(locations.selected.v1,'v8'))}}"
            title="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryId(locations.selected.v1,'v8'))}}"
            [allowClear]="true" (remove)="onRemoveLocation(1)">
            <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
              <div [ngClass]="localService.selectedLanguageCode + '_medium'">
                {{option.data.value}}
              </div>
            </ng-template>
          </ngx-select>
        </div>
      </div>
      <div [ngClass]="isExpand ? 'col-md-3' : 'col-3'">
        <ngx-select (select)="onLocationChanged(3)" *ngIf="locations.districts" [optionValueField]="'key'" [optionTextField]="'s_value'"
          [items]="locations.districts.contents" [(ngModel)]="locations.selected.v3"
          [disabled]="!locations.districts.contents || locations.districts.contents.length == 0"
          placeholder="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryId(locations.selected.v1,'v9'))}}"
          title="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryId(locations.selected.v1,'v9'))}}"
          [allowClear]="true" (remove)="onRemoveLocation(2)">
          <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
            <div [ngClass]="localService.selectedLanguageCode + '_medium'">
              {{option.data.value}}
            </div>
          </ng-template>
        </ngx-select>
      </div>
      <div [ngClass]="isExpand ? 'col-md-3' : 'col-3'">
        <ngx-select (select)="onLocationChanged(4)" *ngIf="locations.constituencies" [optionValueField]="'key'" [optionTextField]="'s_value'"
          [items]="locations.constituencies.contents" [(ngModel)]="locations.selected.v4"
          [disabled]="!locations.constituencies.contents || locations.constituencies.contents.length == 0"
          placeholder="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryId(locations.selected.v1,'v10'))}}"
          title="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryId(locations.selected.v1,'v10'))}}"
          [allowClear]="true" (remove)="onRemoveLocation(3)">
          <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
            <div [ngClass]="localService.selectedLanguageCode + '_medium'">
              {{option.data.value}}
            </div>
          </ng-template>
        </ngx-select>
      </div>
      <div [ngClass]="isExpand ? 'col-md-3' : 'col-3'" *ngIf="IsShowPostalCode">
        <input autocomplete="off" type="text"
          [ngClass]="!locations.selected.v5 || locations.selected.v5 == '' ? '' : 'en'" style="width:calc(100% - 35px);"
          [disabled]="locations.selected.v4 == null || locations.selected.v4 == ''" [(ngModel)]="locations.selected.v5"
          placeholder="{{localService.languageContent.local_locations.postal_code}}"
          title="{{localService.languageContent.local_locations.postal_code}}" (keydown.enter)="onLocationChanged(5)" />
        <i style="float:right;margin-top:10px;" class="material-icons button" (click)="onLocationChanged(5)">search</i>
      </div>
    </div>
  </div>
  <div *ngIf="isVertical">
    <div class="row" *ngIf="!IsShowPostalCode">
      <div class="col-md-12">
        <ngx-select (select)="onLocationChanged(1)" [optionValueField]="'key'" [optionTextField]="'value'"
          [items]="locations.countries" [(ngModel)]="locations.selected.v1"
          placeholder="{{localService.languageContent.local_locations.select_country}}"
          title="{{localService.languageContent.local_locations.select_country}}"
          [disabled]="locations.selected.v1 != '' && locations.countries.length == 1" [noAutoComplete]="true">
          <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
            <span [ngClass]="localService.selectedLanguageCode + '_medium'">{{option.data.value}}</span>
          </ng-template>
        </ngx-select>
      </div>
    </div>
    <div class="row" *ngIf="maxLevelLimit > 1">
      <div class="col-md-12">
        <ngx-select (select)="onLocationChanged(2)" [optionValueField]="'key'" [optionTextField]="'s_value'"
          [items]="locations.states.contents" [(ngModel)]="locations.selected.v2"
          placeholder="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryId(locations.selected.v1,'v8'))}}"
          title="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryId(locations.selected.v1,'v8'))}}"
          [allowClear]="true" (remove)="onRemoveLocation(1)">
          <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
            <div [ngClass]="localService.selectedLanguageCode + '_medium'">
              {{option.data.value}}
            </div>
          </ng-template>
        </ngx-select>
      </div>
    </div>
    <div class="row" *ngIf="maxLevelLimit > 2">
      <div class="col-md-12">
        <ngx-select (select)="onLocationChanged(3)" [optionValueField]="'key'" [optionTextField]="'s_value'"
          [items]="locations.districts.contents" [(ngModel)]="locations.selected.v3"
          [disabled]="!locations.districts.contents || locations.districts.contents.length == 0"
          placeholder="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryId(locations.selected.v1,'v9'))}}"
          title="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryId(locations.selected.v1,'v9'))}}"
          [allowClear]="true" (remove)="onRemoveLocation(2)">
          <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
            <div [ngClass]="localService.selectedLanguageCode + '_medium'">
              {{option.data.value}}
            </div>
          </ng-template>
        </ngx-select>
      </div>
    </div>
    <div class="row" *ngIf="maxLevelLimit > 3">
      <div class="col-md-12">
        <ngx-select (select)="onLocationChanged(4)" [optionValueField]="'key'" [optionTextField]="'s_value'"
          [items]="locations.constituencies.contents" [(ngModel)]="locations.selected.v4"
          [disabled]="!locations.constituencies.contents || locations.constituencies.contents.length == 0"
          placeholder="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryId(locations.selected.v1,'v10'))}}"
          title="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryId(locations.selected.v1,'v10'))}}"
          [allowClear]="true" (remove)="onRemoveLocation(3)">
          <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
            <div [ngClass]="localService.selectedLanguageCode + '_medium'">
              {{option.data.value}}
            </div>
          </ng-template>
        </ngx-select>
      </div>
    </div>
    <div class="row" *ngIf="IsShowPostalCode">
      <div class="col-md-12">
        <input autocomplete="off" type="text"
          [ngClass]="!locations.selected.v5 || locations.selected.v5 == '' ? '' : 'en'" style="width:calc(100% - 35px);"
          [disabled]="locations.selected.v4 == null || locations.selected.v4 == ''" [(ngModel)]="locations.selected.v5"
          placeholder="{{localService.languageContent.local_locations.postal_code}}"
          title="{{localService.languageContent.local_locations.postal_code}}" (keydown.enter)="onLocationChanged(5)" />
        <i style="float:right;margin-top:10px;" class="material-icons button" (click)="onLocationChanged(5)">search</i>
      </div>
    </div>
  </div>
</div>
<span style="display:none;">
  <input type="button" class="on_language_changed" (click)="onLanguageChanged()" />
</span>